import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import discount from "../../assets/images/discount.svg";
import right from "../../assets/images/right.svg";
import timer from "../../assets/images/time.svg";
import { fetchPromotions } from "../../redux/actions/hotelInfoAction";
import { fireGtmEvent } from "../../utils/googleAnalytics";
import useWindowSize from "../../utils/useWindowSize";
import { couponHotels, couponUserId, isValidTimeZone } from "../../utils/utils";
import "./Promotion.css";
import { currency as currencies } from "../../utils/currency";
import { useTranslation } from "react-i18next";
import { fetchPromotionsApi } from "../../Services/mainPageService";

export const RazorpayUI = () => {
  const { t } = useTranslation();
  return (
    <div className="promotionContainer">
      <div className="razorpayoffer">
        <div className="razorpayofferContainer">
          <div className="razorpayHeader">{t("cashback_offer")}</div>
          <div className="razorpayFooter">
            <div className="razorpayLeftFooter">
              <img
                src="https://ik.imagekit.io/hotelzifyprod/7dd2fdb9-36fc-4087-9cec-928f4585b93a.png"
                alt="gpay"
                width={"20px"}
                height={"100%"}
                loading="lazy"
              />{" "}
              <span>{t("more")}</span>
            </div>
            <div className="razorpayLeftFooter">
              <span>{t("secured_by")}</span>
              <img
                src="https://ik.imagekit.io/hotelzifyprod/b5fa4a3b-de7e-4c90-85df-5e2f93ba05c6.png"
                alt="razorpay"
                width={"70px"}
                loading="lazy"
                height={"100%"}
              />{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const MobiQwikUi = () => {
  const { t } = useTranslation();
  return (
    <div className={"promotionContainer bulk"}>
      <div className="promotionContent ">
        <div className="promotionText">
          <p>{t("use_mobikwik")}</p>

          <h1>{t("cashback_offer_mobiqwik")}</h1>
        </div>
        <img
          width={"100%"}
          height={"100%"}
          style={{ objectFit: "contain", width: "30px", height: "30px" }}
          alt="discount offer"
          src={
            "https://ik.imagekit.io/hotelzifyprod/MBK%20CMYK_MBK%20Icon%20Logo_Blue_Z-S4_Fmdp.png"
          }
        />
      </div>
    </div>
  );
};

const Promotion = ({
  isCOD,
  showCancel,
  lastDate,
  handleShowHourly,
  isBNPL = false,
  selectedIds = [392],
}) => {
  const {
    hotelData: { id, currency, autoAccept, userId },
    dateRange: { startDate, endDate },
    payments,
    isHourlyRoom,
    showHourly,
    isRatePlans,
    hotelData,
    // promotions = [],
  } = useSelector((state) => state.hotelInfo);

  const dispatch = useDispatch();

  const [count, setCount] = useState(0);

  const { t } = useTranslation();

  const { width } = useWindowSize();
  const [showRazorpay, setShowRazorpay] = useState(false);
  const [showMobikwik, setShowMobikwik] = useState(false);
  const [promotions, setPromotions] = useState([]);

  useEffect(() => {
    let temp = 0;
    if (isCOD) {
      temp += 1;
    }
    if (showCancel) {
      temp += 1;
    }

    if (width <= 901) {
      temp += 1;
    }
    if (userId === 63809) {
      temp += 1;
    }

    setCount(temp);
  }, [isCOD, showCancel, width]);

  useEffect(() => {
    const getpromos = async () => {
      let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (!isValidTimeZone(timeZone)) {
        timeZone = null;
      } else {
        timeZone = encodeURIComponent(timeZone);
      }
      let url = timeZone
        ? `${id}&checkInDate=${dayjs(startDate).format(
            "DD/MM/YYYY"
          )}&checkOutDate=${dayjs(endDate).format(
            "DD/MM/YYYY"
          )}&shouldApplyFilter=false&timezone=${timeZone}`
        : `${id}&checkInDate=${dayjs(startDate).format(
            "DD/MM/YYYY"
          )}&checkOutDate=${dayjs(endDate).format(
            "DD/MM/YYYY"
          )}&shouldApplyFilter=false`;
      const resp = await fetchPromotionsApi(url);
      if (resp?.status === 200 && resp?.data?.length > 0) {
        if (couponUserId.includes(userId)) {
          setPromotions(resp?.data);
        } else {
          setPromotions(resp?.data?.filter((pr) => pr?.type !== "coupon"));
        }
        // setPromotions(resp?.data?.filter((pr) => pr?.type !== "coupon"));
      } else {
        setPromotions([]);
      }
    };
    id && getpromos();
  }, [id, endDate]);

  useEffect(() => {
    const promElement = document.querySelectorAll(".promotionText");

    changeThemeColor();
  }, [selectedIds]);

  function changeThemeColor() {
    console.log("promotion");
    let color = "linear-gradient(95deg,#53b2fe,#065af3)";
    let textClr = "#0078d4";
    let amenityFilter = "";
    let discountClr = "";
    let promotionText = "";
    let bulkBackground = "";
    let bulkBorder = "none";
    let earlyBackground = "";
    let earlyBorder = "none";
    let imageFilter = "";

    if (hotelData?.userId === 63809) {
      color = "#892680";
    }
    if (
      hotelData?.id === 29727 ||
      hotelData?.id === 29903 ||
      hotelData?.id === 29947 ||
      hotelData?.id === 29946
    ) {
      color = "#88B341";
    }

    if (hotelData?.userId === 127534) {
      color = "#ffcc09";
    }
    if (hotelData?.chainName === "beacon" || hotelData?.id === 2825) {
      color = "#2a5470";
    }
    if (hotelData?.chainName === "zinc") {
      color = "#D2812B";
    }
    if (hotelData?.userId === 106023 || hotelData?.id === 392) {
      color = "#2B4039";
      textClr = "#2B4039";
      discountClr = "#B55B5A";
      amenityFilter =
        "brightness(0) saturate(100%) invert(17%) sepia(10%) saturate(700%) hue-rotate(120deg) brightness(85%) contrast(95%)";
      bulkBackground = "#2B4039";
      bulkBorder = "#1F2A26";
      earlyBackground = "#B55B5A";
      earlyBorder = "#923F3E";
      promotionText = "white";
      imageFilter = "none";
    }
    document.documentElement.style.setProperty("--blue", color);
    document.documentElement.style.setProperty("--blueText", textClr);

    if (
      hotelData?.chainName === "beacon" ||
      hotelData?.chainName === "zinc" ||
      hotelData?.id === 2825
    ) {
      document.documentElement.style.setProperty(
        "--volte",
        '"Roboto", sans-serif'
      );
      document.documentElement.style.setProperty(
        "--firasans",
        '"Roboto", sans-serif'
      );
    }
    // club mahindra
    if (hotelData?.userId === 106023 || hotelData?.id === 392) {
      document.documentElement.style.setProperty(
        "--volte",
        "'Source Sans 3', 'Poppins', 'Inter', sans-serif"
      );
      document.documentElement.style.setProperty(
        "--firasans",
        "'Source Sans 3', 'Poppins', 'Inter', sans-serif"
      );
      document.querySelectorAll(".promotionContent img").forEach((el) => {
        el.style.filter = imageFilter; // Apply the image filter (reset it)
      });
      document.querySelectorAll(".landingPage__Amenity").forEach((el) => {
        el.style.filter = amenityFilter;
      });
      document.querySelectorAll(".promotionText").forEach((el) => {
        el.style.color = promotionText;
      });

      document.querySelectorAll(".recommended").forEach((el) => {
        el.style.color = discountClr;
        el.style.border = `1px solid ${discountClr}`;
      });
      document.querySelectorAll(".discountedPrice").forEach((el) => {
        el.style.color = discountClr;
      });
      console.log("coming here?");
      document.querySelectorAll(".bulk").forEach((el) => {
        el.style.background = bulkBackground;
        el.style.border = `1px solid ${bulkBorder}`;
      });

      document.querySelectorAll(".early").forEach((el) => {
        el.style.background = earlyBackground;
        el.style.border = `1px solid ${earlyBorder}`;
      });
    }
  }

  const hotelAddonRef = useRef();

  const scrollAddon = (width) => {
    hotelAddonRef.current.scrollLeft += width;
  };

  useEffect(() => {
    setShowRazorpay(
      payments?.some((pay) =>
        ["Razorpay", "PartialPayment"].includes(pay?.Gateway?.name)
      )
    );
    setShowMobikwik(
      payments?.some((pay) =>
        ["Razorpay", "PartialPayment"].includes(pay?.Gateway?.name)
      )
    );
  }, [payments]);

  const promoTexts = (type, discount) => {
    let txt = "";
    switch (type) {
      case "nights":
        txt = Number(discount) === 1 ? "night" : "nights";
        break;
      case "fixed_amount":
        txt = currencies(currency);
        break;
      case "percentage":
        txt = "%";
        break;
    }
    return txt;
  };

  return (
    <div className="promotionComponent" id="promotionComponentId">
      {
        <div className="promoBtns">
          <p
            className="hideBig"
            style={{
              fontWeight: "bold",
              color: "#00800a",
              textAlign: "left",
              width: "100%",
            }}
          >
            {t("limited_offer")}
          </p>
          {promotions?.length + count > 1 && (
            <span className="scrollBtns">
              {" "}
              <img
                src={right}
                alt="scroll left"
                onClick={() => scrollAddon(-300)}
                style={{ transform: "rotate(180deg)" }}
                height="100%"
                width={"20px"}
              />{" "}
              <img
                src={right}
                alt="scroll right"
                height="100%"
                width={"20px"}
                onClick={() => scrollAddon(300)}
              />
            </span>
          )}
        </div>
      }
      <div className="promotion" ref={hotelAddonRef}>
        {/* {showMobikwik && <MobiQwikUi />}
        {showRazorpay && <RazorpayUI />} */}
        {showHourly && !isHourlyRoom && (
          <div
            className="promotionContainer early"
            style={{
              cursor: "pointer",
              color: "black",

              boxShadow:
                "3px 3px 5px rgba(0,0,0,0.2),-3px -3px 5px rgba(0,0,0,0.2)",
              marginLeft: "5px",
            }}
            onClick={() => {
              fireGtmEvent("hourlyClicked_promotion");
              fireGtmEvent("hourly");
              handleShowHourly();
            }}
          >
            <div className="promotionContent ">
              <div className="promotionText">
                <p className="blink"> {t("click_here")}</p>
                <h1>{t("hourly_room_booking")} ⏳</h1>
              </div>
              <img
                width={"30px"}
                height={"30px"}
                alt="discount offer"
                style={{
                  filter:
                    "invert(52%) sepia(60%) saturate(642%) hue-rotate(342deg) brightness(85%) contrast(95%)",
                }}
                src={timer}
              />
            </div>
          </div>
        )}

        {/* {currency === "INR" && (
          <div
            className="promotionContainer bulk hideBig"
            style={{ overflow: "hidden" }}
          >
            <img
              src="https://ik.imagekit.io/hotelzifyprod/0d490838-f25a-4cd3-8724-e5d07802a613.png"
              alt="hotelzify gift voucher"
              className="voucherPromo"
              width={"100%"}
              height={"70px"}
            />
          </div>
        )} */}
        {!isRatePlans && showCancel && (
          <div className={"promotionContainer early"}>
            <div className="promotionContent ">
              <div className="promotionText">
                <p>{t("no_worries_cancel")}</p>

                <h1 style={{ fontSize: "1rem" }}>
                  {t("free_cancellation_till")} {lastDate}
                </h1>
              </div>
              <img
                width={"30px"}
                height={"30px"}
                alt="discount offer"
                src={timer}
                style={{
                  filter:
                    "invert(52%) sepia(60%) saturate(642%) hue-rotate(342deg) brightness(85%) contrast(95%)",
                }}
              />
            </div>
          </div>
        )}
        {!isHourlyRoom &&
          promotions?.map((promo, idx) => {
            return (
              <div
                className={
                  promo?.type === "bulk"
                    ? "promotionContainer bulk"
                    : "promotionContainer early"
                }
                key={idx}
              >
                {promo?.type === "bulk" ? (
                  <div className="promotionContent">
                    <div className="promotionText">
                      <p>
                        {/* {t("on_bookings_above")}{" "}
                        {promo?.cutoffAmount > 1
                          ? promo?.cutoffAmount
                          : promo?.lengthOfStay}{" "}
                        {promoTexts(
                          promo?.discountType,
                          promo?.cutoffAmount > 1
                            ? promo?.cutoffAmount
                            : promo?.lengthOfStay
                        )}{" "}
                        {t("get")} */}
                        <span style={{ fontWeight: "600", fontSize: "14px" }}>
                          {" "}
                          {promo?.name}
                        </span>{" "}
                        {promo?.promotionCta1}
                        <h1 style={{ display: "inline", margin: 0 }}>
                          {promo?.promotionCta2}
                          {/* {t("flat")} {parseInt(promo?.discount)}{" "}
                        {promoTexts(promo?.discountType, promo?.discount)}{" "}
                        {t("off")} */}
                        </h1>
                      </p>
                    </div>
                    <img
                      width={"30px"}
                      height={"30px"}
                      alt="discount offer"
                      style={{
                        filter:
                          "invert(68%) sepia(77%) saturate(1301%) hue-rotate(188deg) brightness(101%) contrast(88%)",
                      }}
                      src={discount}
                    />
                  </div>
                ) : null}
                {promo?.type === "coupon" ? (
                  <div className="promotionContent">
                    <div className={`promotionText`}>
                      <p>{t("use_code")}</p>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <h1>'{promo?.name}'</h1>
                        <p>
                          {t("and")} {promo?.promotionCta2}{" "}
                        </p>
                      </div>
                    </div>
                    <img
                      width={"30px"}
                      height={"30px"}
                      alt="discount offer"
                      style={{
                        filter:
                          "invert(68%) sepia(77%) saturate(1301%) hue-rotate(188deg) brightness(101%) contrast(88%)",
                      }}
                      src={discount}
                    />
                  </div>
                ) : null}

                {["basic", "day", "custom"].includes(promo?.type) ? (
                  <div className="promotionContent ">
                    <div className="promotionText">
                      {promo?.type === "custom" ? (
                        <>
                          <p>{promo?.name}</p>
                        </>
                      ) : (
                        <>
                          {" "}
                          <p>
                            {" "}
                            <span
                              style={{ fontWeight: "600", fontSize: "14px" }}
                            >
                              {promo?.name}
                            </span>{" "}
                          </p>
                          <p style={{ fontWeight: "600", fontSize: "14px" }}>
                            {promo?.promotionCta1}{" "}
                            <h1>
                              {promo?.promotionCta2}
                              {/* {t("flat")} {parseInt(promo?.discount)}{" "}
                        {promoTexts(promo?.discountType, promo?.discount)}{" "}
                        {t("off")} */}
                            </h1>
                          </p>
                        </>
                      )}
                    </div>
                    <img
                      width={"30px"}
                      height={"30px"}
                      alt="discount offer"
                      style={{
                        filter:
                          "invert(52%) sepia(60%) saturate(642%) hue-rotate(342deg) brightness(85%) contrast(95%)",
                      }}
                      src={discount}
                    />
                  </div>
                ) : null}
                {promo?.type === "early" ? (
                  couponHotels.includes(id) ? (
                    <div className="promotionContent">
                      <img
                        width={"30px"}
                        height={"30px"}
                        alt="discount offer"
                        src={timer}
                        style={{
                          filter:
                            "invert(52%) sepia(60%) saturate(642%) hue-rotate(342deg) brightness(85%) contrast(95%)",
                        }}
                      />
                      <div className="promotionText">
                        <p>{t("use_code")}</p>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <h1>'MOUNT'</h1>
                          <p>
                            {t("and_get")} {parseInt(promo?.discount)}{" "}
                            {promoTexts(promo?.discountType, promo?.discount)}{" "}
                            {t("off")}
                          </p>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="promotionContent">
                      <img
                        width={"30px"}
                        height={"30px"}
                        alt="discount offer"
                        src={timer}
                        style={{
                          filter:
                            "invert(52%) sepia(60%) saturate(642%) hue-rotate(342deg) brightness(85%) contrast(95%)",
                        }}
                      />
                      <div className="promotionText">
                        {/* <p>{promo.name}</p> */}
                        <p>{t("early_bird_offer")} !!</p>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <h1>
                            {parseInt(promo?.discount)}{" "}
                            {promoTexts(promo?.discountType, promo?.discount)}{" "}
                            {t("off")}
                          </h1>
                          <p>
                            {t("book")} {promo?.cutoffDays} {t("days_advance")}{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  )
                ) : null}
                {promo?.type === "late" ? (
                  couponHotels.includes(id) ? (
                    <div className="promotionContent">
                      <img
                        width={"30px"}
                        height={"30px"}
                        alt="discount offer"
                        src={timer}
                        style={{
                          filter:
                            "invert(52%) sepia(60%) saturate(642%) hue-rotate(342deg) brightness(85%) contrast(95%)",
                        }}
                      />
                      <div className="promotionText">
                        <p>{t("use_code")}</p>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <h1>'MOUNT'</h1>
                          <p>
                            {t("and_get")} {parseInt(promo?.discount)}{" "}
                            {promoTexts(promo?.discountType, promo?.discount)}{" "}
                            {t("off")}
                          </p>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="promotionContent">
                      <img
                        width={"30px"}
                        height={"30px"}
                        alt="discount offer"
                        src={timer}
                        style={{
                          filter:
                            "invert(52%) sepia(60%) saturate(642%) hue-rotate(342deg) brightness(85%) contrast(95%)",
                        }}
                      />
                      <div className="promotionText">
                        <p>{t("last_minute_deals")} !!</p>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <h1>
                            {parseInt(promo?.discount)}{" "}
                            {promoTexts(promo?.discountType, promo?.discount)}{" "}
                            {t("off")}
                          </h1>
                          <p>
                            {t("book_now_for")}{" "}
                            {dayjs(startDate).format("MMM DD")}
                          </p>
                        </div>
                      </div>
                    </div>
                  )
                ) : null}
              </div>
            );
          })}
        {/* {userId === 63809 && (
          <div className={"promotionContainer bulk"}>
            <div className="promotionContent ">
              <div className="promotionText">
                <h1 style={{ fontSize: "0.9rem" }}>
                  Mandatory gala dinner on 24th & 31st Dec
                </h1>
                <p>Hotel will contact you for the same</p>
              </div>
            </div>
          </div>
        )} */}
        {userId === 103376 && (
          <div className={"promotionContainer bulk"}>
            <div className="promotionContent ">
              <div className="promotionText">
                <h1 style={{ fontSize: "0.9rem" }}>20% off </h1>
                <p>On dining and laundry service for solo women travellers</p>
              </div>
            </div>
            {/* <img
              width={"30px"}
              height={"30px"}
              alt="discount offer"
              style={{
                filter:
                  "invert(68%) sepia(77%) saturate(1301%) hue-rotate(188deg) brightness(101%) contrast(88%)",
              }}
              src={discount}
            /> */}
          </div>
        )}
        {isBNPL && (
          <div className={"promotionContainer bulk"}>
            <div className="promotionContent ">
              <div className="promotionText">
                <p>{t("flexible_hassle_free_affordable")}</p>

                <h1>{t("book_now_pay_later")}</h1>
              </div>
              <img
                width={"30px"}
                height={"30px"}
                alt="discount offer"
                style={{
                  filter:
                    "invert(68%) sepia(77%) saturate(1301%) hue-rotate(188deg) brightness(101%) contrast(88%)",
                }}
                src={discount}
              />
            </div>
          </div>
        )}
        {autoAccept === 1 && (
          <div className={"promotionContainer bulk"}>
            <div className="promotionContent ">
              <div className="promotionText">
                <p>{t("no_waiting_just_go")}</p>

                <h1>{t("instant_confirmation")}</h1>
              </div>
              <img
                width={"30px"}
                height={"30px"}
                alt="discount offer"
                style={{
                  filter:
                    "invert(68%) sepia(77%) saturate(1301%) hue-rotate(188deg) brightness(101%) contrast(88%)",
                }}
                src={discount}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Promotion;
